import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidatorService } from 'angular-iban';
import { StudentRegistration } from '../../../models/student-registration';
import { RegistrationsService } from '../../../services/registrations/registrations.service';
import { isDate } from 'moment';

import { ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule, MatStepper } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';

export const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD.MM.YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'li-registration-wizard',
  templateUrl: './registration-wizard.component.html',
  styleUrls: ['./registration-wizard.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    CommonModule,
  ],
})
export class RegistrationWizardComponent implements OnInit {

  finished: boolean = false;
  fatality: boolean = false;
  firstFormGroup!: FormGroup;
  secondFormGroup!: FormGroup;
  thirdFormGroup!: FormGroup;

  infoTextAufnahme =
    'Ich erkläre mich damit einverstanden, dass die Tanz- und Sportschule Li-Dance, ' +
    'Inh. Lydia Kolepp die vorstehend angegebenen, zur Einzahlungsvollmacht notwendigen Daten speichert.';

  infoTextDataChange =
    'Änderungen der Anschrift, der Kontaktdaten, der Bankverbindung werde ich unverzüglich bekannt geben. ';

  infoTextPrivacyPolicy =
    'Die <a href="https://li-dance.de/files/dokumente/li-dance-agb.pdf" target="_blank">allgemeinen Geschäftsbedingungen</a> und die <a href="https://li-dance.de/datenschutz.html" target="_blank">Datenschutzerklärung</a> habe ich gelesen und akzeptiere diese.';

  infoTextEinzugermaechtigung =
    'Ich ermächtige die Tanz- und Sportschule Li-Dance, Inh. Lydia Kolepp die Monatsbeiträge, diverse Einmalzahlungen und sonstige ' +
    'Verbindlichkeiten gem. unseres <a href="https://li-dance.de/files/dokumente/li-dance-preisverzeichnis.pdf" target="_blank">Preis- und Leistungsverzeichnisses</a> zu Lasten meines Kontos einzuziehen. ';

  infoTextReturnDebit =
    'Ich habe verstanden und akzeptiere, dass im Falle einer unberechtigten Rücklastschrift Li-Dance ein ' +
    'Verwaltungsaufwand entsteht und eine Gebühr i.H.v. 15,- € berechnet wird. Diese Gebühr wird zusammen mit dem nachfolgenden Monatsbeitrag ' +
    'vom gleichen Konto ohne erneute Erinnerung abgebucht.';

  infoTextEinwilligungserklaerung =
    'Ich bin darüber informiert worden, dass meine personenbezogenen Daten aufgrund rechtlicher ' +
    'Vorgaben mindestens 10 Jahre nach Vertragsende aufbewahrt werden müssen. ' +
    'Ich bin damit einverstanden, dass die in der <a href="https://li-dance.de/files/dokumente/li-dance-datenschutz.pdf" target="_blank">Datenschutzerklärung</a> genannten personenbezogenen Daten zu den dort ' +
    'genannten Zwecken erhoben, gespeichert, verarbeitet, genutzt und ggfs. weitergegeben werden. ' +
    'Ich bin darauf hingewiesen worden, dass die im Rahmen der genannten Zwecke ' +
    'erhobenen persönlichen Daten meiner Person unter Beachtung der EU-' +
    'Datenschutzgrundverordnung (DSGVO) erhoben, gespeichert, genutzt und übermittelt werden. ' +
    'Ich bin zudem darauf hingewiesen worden, dass die Erhebung, Speicherung, Verarbeitung und ' +
    'Nutzung meiner Daten auf freiwilliger Basis erfolgt. ' +
    'Ich bin darüber informiert worden, dass diese Einverständniserklärung jederzeit mit sofortiger ' +
    'Wirkung verweigert, bzw. jederzeit mit Wirkung für die Zukunft widerrufen werden kann. Meine ' +
    'Widerrufserklärung werde ich richten an die Tanz- und Sportschule Li-Dance, Inh. Lydia Kolepp, Dieselstr. 10, 61231 Bad Nauheim';

  infoTextEinverstaendniserklaerung =
    'Ich bin damit einverstanden, dass Bilder und Videos der Tanzschule und der Veranstaltungen, ' +
    'die durch die Tanzschule organisiert sind und/oder an denen die Tanzschule teilnimmt, auf ' +
    'denen ich selbst, mein Sohn oder meine Tochter zu sehen ist auf den Webseiten von Li-Dance und in anderen Online- und/oder Printmedien veröffentlicht ' +
    'werden und für Werbezwecke von Li-Dance genutzt werden dürfen. <br/>' +
    'Rechtsgrundlage: Das Recht am eigenen Bild ist ein Teil des vom Gesetz geschützten ' +
    'allgemeinen Persönlichkeitsrechts (§22 Kunsturheberrechtsgesetz). Es gilt der Grundsatz, dass ' +
    'Bild- und Video-Material nur mit Einwilligung des Abgebildeten verbreitet oder veröffentlicht ' +
    'werden kann. Es handelt sich hierbei um eine rechtsgeschäftliche Willenserklärung. Deshalb ' +
    'kann bei Minderjährigen eine Einwilligung nur durch den gesetzlichen Vertreter erfolgen. ' +
    'Diese Einverständniserklärung kann mit sofortiger Wirkung verweigert, bzw. jederzeit mit ' +
    'Wirkung für die Zukunft widerrufen werden. Ein Widerruf kann einen Ausschluss aus der ' +
    'jeweiligen Veranstaltung zur Folge haben.<br/>' +
    'Ein späterer rückwirkender Widerruf für aktuell stattfindende bzw. bereits stattgefundene ' +
    'Veranstaltungen ist ausgeschlossen.';

  constructor(
    private _formBuilder: FormBuilder,
    private registrationsService: RegistrationsService
  ) {}

  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      birthday: ['', Validators.required],
      street: ['', Validators.required],
      house: ['', [Validators.required, Validators.pattern(/^[0-9]+$/)]],
      zip: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      city: ['', Validators.required],
      phone: ['', [Validators.required, Validators.pattern(/^(\+?\d{1,3})?[ ]*\d{9,}$/)]],
      gender: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      contractType: ['', Validators.required],
      applicationConsent: [false, Validators.requiredTrue],
      dataChangeConsent: [false, Validators.requiredTrue],
      privacyPolicyConsent: [false, Validators.requiredTrue],
    });

    this.secondFormGroup = this._formBuilder.group({
      accountHolder: ['', Validators.required],
      iban: ['', [Validators.required, ValidatorService.validateIban]],
      bic: ['', [Validators.required, Validators.pattern(/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/)]],
      bank: ['', Validators.required],
      directDebitConsent: [false, Validators.requiredTrue],
      returnDebitConsent: [false, Validators.requiredTrue],
    });

    this.thirdFormGroup = this._formBuilder.group({
      dataStorageConsent: [false, Validators.requiredTrue],
      multimediaConsent: [false, Validators.requiredTrue],
    });

    this.secondFormGroup.get('iban')?.valueChanges.subscribe(value => {
      if (value) {
        this.capitalizeFirstTwoLetters();
      }
    });
  }

  get registrationDate(): Date {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    const currentDate = today.getDate();

    if (currentDate === 1) {
      return new Date(currentYear, currentMonth, 1);
    } else if (currentDate <= 20) {
      return new Date(currentYear, currentMonth, 15);
    } else {
      return new Date(currentYear, currentMonth + 1, 1);
    }
  }

  get registrationPrice(): number {
    const age = this.age ?? 0;
    const contractType = this.firstFormGroup.get('contractType')?.value
      ? Number(this.firstFormGroup.get('contractType')?.value)
      : 0;

    switch (contractType) {
      case 2:
        return 40;
      case 3:
        return 45;
      default:
        if (age >= 4 && age <= 6) {
          return 40;
        } else if (age >= 7 && age <= 17) {
          return 50;
        } else if (age >= 18) {
          return 60;
        } else {
          return 0;
        }
    }
  }

  get age(): number {
    const birthdateCtrl = this.firstFormGroup.get('birthday')?.value;
    if (!birthdateCtrl) {
      return 0;
    }

    const birthdate: Date =
      birthdateCtrl.toDate?.() ?? birthdateCtrl;
    if (!isDate(birthdate)) {
      return 0;
    }

    const currentDate = new Date();
    let age = currentDate.getFullYear() - birthdate.getFullYear();
    const monthDifference = currentDate.getMonth() - birthdate.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && currentDate.getDate() < birthdate.getDate())
    ) {
      age--;
    }

    return age;
  }

  capitalizeFirstTwoLetters() {
    let ibanValue = this.secondFormGroup.get('iban')?.value;
    if (ibanValue && ibanValue.length >= 2) {
      this.secondFormGroup.patchValue(
        {
          iban:
            ibanValue.substring(0, 2).toUpperCase() +
            ibanValue.substring(2),
        },
        { emitEvent: false }
      );
    }
  }

  removeWhiteSpace(input: string): string {
    return input.replace(/\s+/g, '');
  }

submit() {
  if (this.thirdFormGroup.invalid) {
    return;
  }

  const registrationData = {
    ...this.firstFormGroup.value,
    ...this.secondFormGroup.value,
    ...this.thirdFormGroup.value
  };

  this.registrationsService.set(registrationData).subscribe({
  next: () => this.finished = true,
  error: (err) => { this.finished = true; this.fatality = true },
});
}
}
